export default "__VITE_ASSET__BodlbH6W__"